if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core_combofun","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(4(17|27|84)|8(31|76|97)|(12|27|76)7|368|399|555|689|953)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}